import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import UserSettingsFinPageUI from './UserSettingsFinPageUI.js'

class UserSettingsFinPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      user: null,
      paymentCard: null,
      messageList: null,
      errorList: [],
    }
  }

  render() {
    return (
      <UserSettingsFinPageUI
        context={this.props.context}
        user={this.state.user}
        paymentCard={this.state.paymentCard}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        //
        onEmailUpdated={this.onEmailUpdated}
        onNameUpdated={this.onNameUpdated}
        onPhoneUpdated={this.onPhoneUpdated}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getUser(context)
    if (context.session.appCode === 'finapp')
      this.getPaymentCard(context)
    this.getMessages(context)
  }

  getUser(context) {
    let cacheManager = new CacheManager({
      resource: '/api/user',
      cacheKey: CacheKeys.User(context.session.userId),
      callback: this.getUserCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getUserCallback = (response) => {
    this.setState({errorList: response.errorList, user : response})
  }

  getPaymentCard(context) {
    let cacheManager = new CacheManager({
      resource: `/api/user/accounts/${context.session.accountId}/paymentCard`,
      cacheKey: CacheKeys.PaymentCard(context.session.accountId, context.session.userId),
      callback: this.getPaymentCardCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPaymentCardCallback = (response) => {
    this.setState({errorList: response.errorList, paymentCard : response.paymentCard})
  }

  onEmailUpdated = (email) => {
    let user = this.state.user
    user.email = email
    this.setState({user: user})
    CacheManager.removeObject(CacheKeys.User(this.props.context.session.userId));
    // user needs to be fetched again so that the avatar gets updated
    this.getUser(this.props.context)
  }

  onNameUpdated = (firstName, lastName) => {
    let user = this.state.user
    user.firstName = firstName
    user.lastName = lastName
    this.setState({user: user})
    CacheManager.removeObject(CacheKeys.User(this.props.context.session.userId));
  }

  onPhoneUpdated = (phoneNumber) => {
    let user = this.state.user
    user.phoneNumber = phoneNumber
    this.setState({user: user})
    CacheManager.removeObject(CacheKeys.User(this.props.context.session.userId));
    this.getUser(this.props.context)
    setTimeout(() => {
      this.props.history.push(`/settings/user/fin`)
    }, 3000)
  }

  getMessages(context) {
    let arr = [
      'c_user_settings',
      'c_email',
      'c_phone_number',
      'c_name',
      'c_first_name',
      'c_last_name',
      'c_photo',
      'c_password',
      'c_payment_card',
      'c_old_password',
      'c_new_password',
      'c_reenter_password',
      'c_pin_code',
      'c_old_pincode',
      'c_new_pincode',
      'c_reenter_pincode',
      'c_email_notifications',
      'c_connected_accounts',
      'c_connected_projects',
      'c_create_avatar_msg',
      'c_update',
      'c_cancel',
      'c_fb_user_passwd',
      'c_g_user_passwd'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_user_st_fin', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default UserSettingsFinPageSF
